import React, { Component } from "react";

import PropTypes from "prop-types";

import { BrowserRouter, Switch, Redirect, Route } from "react-router-dom";
import Employee from "../Employee";
import HomePage from "../HomePage";
import AdminPage from "../AdminPage";
import UserPage from "../UserPage";
import NotFoundPage from "../NotFoundPage";
import Managers from "../Managers";
import AddEmployee from "../AddEmployee";
import Transactions from "../Transactions";
import ManagerTransactions from "../ManagerTransactions";
class Router extends Component {
  render() {
    // Properties
    const { user, roles, bar } = this.props;

    // Functions
    const { openSnackbar } = this.props;
    console.log("User role",roles.includes("admin"));

    return (
      <BrowserRouter basename={process.env.REACT_APP_BASENAME}>
        {bar}

        <Switch>
          <Route path="/" exact>
            <HomePage user={user} openSnackbar={openSnackbar} />
          </Route>
          <Route exact path="/managers/:managerId/employee">
            {user ? <Employee  openSnackbar={openSnackbar}/> : <Redirect to="/" />}
          </Route>
          <Route exact path="/managers/:managerId/addEmployee">
            {user ? <AddEmployee openSnackbar={openSnackbar} /> : <Redirect to="/" />}
          </Route>
          <Route path="/admin">
            {user ? (
              <AdminPage openSnackbar={openSnackbar} />
            ) : (
              <Redirect to="/" />
            )}
          </Route>
          <Route path="/managers">
            {user ? (
              <Managers roles={roles} openSnackbar={openSnackbar} />
            ) : (
              <Redirect to="/" />
            )}
          </Route>
          <Route path="/transactions/:workerId">
            {user ? <Transactions /> : <Redirect to="/" />}
          </Route>
          <Route path="/managertransactions/:managerId">
            {user ? <ManagerTransactions /> : <Redirect to="/" />}
          </Route>
          <Route path="/user/:userId">
            {user ? <UserPage /> : <Redirect to="/" />}
          </Route>

          <Route>
            <NotFoundPage />
          </Route>
        </Switch>
      </BrowserRouter>
    );
  }
}

Router.propTypes = {
  // Properties
  user: PropTypes.object,
  roles: PropTypes.array.isRequired,
  bar: PropTypes.element,

  // Functions
  openSnackbar: PropTypes.func.isRequired,
};

export default Router;
